export const storage = {
  setObject<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  },

  getObject<T>(key: string): T | null {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  },

  remove(key: string): void {
    localStorage.removeItem(key);
  }
};
